export default __webpack_public_path__ + "static/media/vision.7f998fb9.png";